import type { Lang } from '@platform/core/types';
import { monthStart } from './partyCalendarModel';

/** Підписи дат календаря партії (прототип v4 pcal: локаль uk-UA / en-GB). Чисті функції. */
const LOCALE: Record<Lang, string> = { uk: 'uk-UA', en: 'en-GB' };

const at = (iso: string) => new Date(`${iso}T00:00`);

/** Заголовок місяця з великої літери: «Жовтень 2026 р.» / «October 2026». */
export function monthTitle(month: string, lang: Lang): string {
  const text = monthStart(month).toLocaleDateString(LOCALE[lang], { month: 'long', year: 'numeric' });
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Число й скорочений місяць: «26 жовт.» / «26 Oct». */
export function dayLabel(iso: string, lang: Lang): string {
  return at(iso).toLocaleDateString(LOCALE[lang], { day: 'numeric', month: 'short' });
}

/** Скорочений день тижня: «пн» / «Mon». */
export function weekdayLabel(iso: string, lang: Lang): string {
  return at(iso).toLocaleDateString(LOCALE[lang], { weekday: 'short' });
}
